import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  translatingLoaderText: {
    id: 'unit-translation-selector-plugin.translationsLoader.loaderText',
    defaultMessage: 'Translating',
    description: 'Translating text shown when translating to a language',
  },
  translatingLoaderAdditionalTextFirstLine: {
    id: 'unit-translation-selector-plugin.translationsLoader.additionalTextFirstLine',
    defaultMessage: 'Wow, you’re the first person to translate to this language!',
    description: 'First line of additional message shown after a short delay if translation takes longer than expected',
  },
  translatingLoaderAdditionalTextWaitNote: {
    id: 'unit-translation-selector-plugin.translationsLoader.additionalTextWaitNote',
    defaultMessage: 'This may take a few more seconds than usual, hang tight.',
    description: 'Wait note for additional message',
  },
});

export default messages;
